<template>
  <h2 class="h4 text-white px-2 py-2 pr-6">
    <slot>
      {{ text }}
    </slot>
  </h2>
</template>
<script>

export default {
  props : {
    text: {
      type:String,
      required:false,
      default: ''
    }
  }
}
</script>

